import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchFileFoldersList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/file-folders', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
